import { route } from './route';

const forObligor = (obligorId: number) => ({ id: String(obligorId) });

export const obligorRoutes = {
    detail: (obligorId: number) => route('/(app)/obligors/[id=integer]', forObligor(obligorId)),
    auditHistory: (obligorId: number) => route('/(app)/obligors/[id=integer]/audit-history', forObligor(obligorId)),
    bankruptcies: (obligorId: number) => route('/(app)/obligors/[id=integer]/bankruptcies', forObligor(obligorId))
};
